<template>
    <v-dialog 
        v-model="dialogOrder" 
        max-width="1000px"
        persistent
    >
        <v-card>
            <v-overlay :value="overlay">
            <v-progress-circular
                indeterminate
                :absolute=true
                size="64"
            ></v-progress-circular>
            </v-overlay>
            <v-card-title>
            <span class="headline">Detalle de la orden </span>
            </v-card-title>
            <v-card-text class="px-0">
                <v-container fluid>
                    <v-row>
                        <v-col 
                            cols="12"
                            md="4"
                            style="border-right:1px solid silver"
                        >
                            <v-list class="py-0">
                                <v-list-item >
                                    <v-list-item-avatar  >
                                    <v-icon color="primary">mdi-36px mdi-checkbox-multiple-marked-outline</v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                    <v-list-item-title>Orden</v-list-item-title>
                                    <v-list-item-subtitle>{{dataDetailOrder.order}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            <v-list class="py-0">
                                <v-list-item>
                                    <v-list-item-avatar  >
                                    <v-icon color="primary">mdi-36px mdi-account-circle</v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                    <v-list-item-title>Paciente</v-list-item-title>
                                    <v-list-item-subtitle>{{dataDetailOrder.patient}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            <v-list class="py-0">
                                <v-list-item>
                                    <v-list-item-avatar  >
                                    <v-icon color="primary">mdi-36px mdi-account-box-outline</v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                    <v-list-item-title>Identificación</v-list-item-title>
                                    <v-list-item-subtitle>{{dataDetailOrder.identification}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            <v-list class="py-0">
                                <v-list-item
                                    
                                >
                                    <v-list-item-avatar >
                                    <v-icon color="primary">mdi-36px mdi-account-star</v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                    <v-list-item-title>Médico</v-list-item-title>
                                    <v-list-item-subtitle>{{dataDetailOrder.doctor}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            <v-list class="py-0">
                                <v-list-item >
                                    <v-list-item-avatar >
                                    <v-icon color="primary">mdi-36px mdi-calendar</v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                    <v-list-item-title>Fecha</v-list-item-title>
                                    <v-list-item-subtitle>{{dataDetailOrder.date}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            <v-list class="py-0">
                                <v-list-item >
                                    <v-list-item-avatar >
                                    <v-icon color="primary">mdi-36px mdi-city</v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                    <v-list-item-title>Empresa</v-list-item-title>
                                    <v-list-item-subtitle>{{(dataDetailOrder.empresa_id == null ||  dataDetailOrder.empresa_id =='') ? 'Particular' : dataDetailOrder.company}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            <v-list class="py-0">
                                <v-list-item >
                                    <v-list-item-avatar >
                                    <v-icon color="primary">mdi-36px mdi-check-circle-outline</v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                    <v-list-item-title>Estado</v-list-item-title>
                                    <v-list-item-subtitle>{{state}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            <v-list class="py-0">
                                <v-list-item >
                                    <v-list-item-avatar >
                                    <v-icon color="primary">mdi-36px mdi-email</v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                    <v-list-item-title>Correo</v-list-item-title>
                                    <v-list-item-subtitle>{{dataDetailOrder.email}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            <v-list class="py-0">
                                <v-list-item >
                                    <v-list-item-content>
                                    <v-list-item-title>
                                        <v-btn 
                                            small color='primary'
                                            @click=sendAccess
                                        >
                                            <v-icon>mdi-email-outline</v-icon> Enviar accesos
                                        </v-btn>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-col>
                        <v-col 
                            cols="12"
                            md="8"
                        >
                            <v-simple-table 
                                dense 
                            >
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                        <th class="text-left">Examenes</th>
                                        <th class="text-center">Proveedor</th>
                                        <th class="text-center">Resultados</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(detail, x) in dataDetailOrder.details" :key="x">
                                        
                                            <td style="boder:1px solid">{{detail.desc_item}}</td>
                                            <td 
                                                style="border: 1px solid silver;" 
                                                class="text-center"
                                                v-if="detail.print" 
                                                :rowspan="detail.rowspan"
                                            >
                                                {{detail.proveedor}}
                                            </td>
                                            <td 
                                                style="border: 1px solid silver;width: 200px;padding: 5px;"
                                                class="text-center" 
                                                v-if="detail.print" 
                                                :rowspan="detail.rowspan"
                                            >
                                                <v-btn 
                                                    small 
                                                    color="primary" 
                                                    target="_blank" 
                                                    @click="viewPdf(detail.archive.split('/')[detail.archive.split('/').length-1].toString(),'pdf')"
                                                    v-if="detail.archive.split('/')[detail.archive.split('/').length-1].toString() != 'null.pdf' &&
                                                            detail.archive.split('/')[detail.archive.split('/').length-1].toString() != '' &
                                                            detail.archive.split('/')[detail.archive.split('/').length-1].toString() != 'NaN.pdf'"
                                                >
                                                    <v-icon>mdi-file-pdf</v-icon> Ver archivo
                                                </v-btn>
                                                <div v-else style="width:auto">
                                                    <v-form>
                                                        <v-checkbox
                                                            v-model="detail.check"
                                                            label="Agregar Logo y pie"
                                                            @click=setHeaderFeet(detail)
                                                        ></v-checkbox>
                                                        <v-file-input
                                                            :id=x.toString()
                                                            accept="application/pdf"
                                                            label="Archivo"
                                                            name=file
                                                            prepend-icon=''
                                                            clear-icon='mdi-cancel'
                                                            @click:clear=setFileC(detail)
                                                            :append-icon="detail.fileCharged ? 'mdi-eye' : ''"
                                                            @click:append="previewFile(detail.path,'temp')"
                                                            dense
                                                            @change=setFile($event,detail)
                                                        ></v-file-input>
                                                    </v-form>
                                                </div>
                                                <v-btn 
                                                    small 
                                                    class="mt-3"
                                                    color="warning"
                                                    v-if="detail.archive.split('/')[detail.archive.split('/').length-1].toString() != 'null.pdf' &&
                                                            detail.archive.split('/')[detail.archive.split('/').length-1].toString() != '' &&
                                                            detail.archive.split('/')[detail.archive.split('/').length-1].toString() != 'NaN.pdf'"
                                                    @click=deleteFile(detail)
                                                >
                                                    <v-icon>mdi-delete-forever</v-icon> Eliminar
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-col cols="12" class="text-center">
                <v-btn 
                    color="primary" 
                    class="mx-2" 
                    @click=storeFile 
                    v-if="1==1"
                >
                    <v-icon>mdi-cloud-upload</v-icon> Cargar
                </v-btn>
                <v-btn color="secondary" class="mx-2" @click=closeDialogOrder() >
                    <v-icon >mdi-cancel</v-icon> Cerrar
                </v-btn>
            </v-col>
        </v-card>
    </v-dialog>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'
import axios from 'axios'
export default {
     props:{
        dialogOrder:{
            type: Boolean,
            default: false
        },
        state:{
            type: String,
            default: ''
        },
        dataDetailOrder:{
            type: Object,
            defult: () => {}
        },
        overlay:{
            type: Boolean,
            default: false
        },
    },
    data: ()=>({
        file:[],
    }),
    computed:{
        ...mapState([
            'idActionsRol',
            'loadingTable',
            'user',
            'url',
            'statesListOrder',
            'pathFileOrder',
            'directoryPDF',
            'directoryTemp',
            'directoryComplement',
            'urlApi',
            'token'
        ]),
    },
    methods:{

        ...mapMutations(['setUrl','setLoadingTable','setLoadingBtn']),

        ...mapActions(['requestApi','alertNotification']),
        
        setFile(data,detail){
            if(typeof data != 'undefined'){
                this.$emit('setOverlay',true)   
                let formData = new FormData();
                formData.append('file_0',data)
                formData.append('directoryTemp', this.directoryTemp)
                formData.append('data', JSON.stringify([detail]))
                formData.append('preview',true)
                formData.append('pathCompleMent',this.directoryComplement)
                this.setUrl('ordenes-laboratorio')
                axios.post(
                    this.url,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': 'Bearer '+ this.token
                        }
                    }
                ).then(res=>{
                    let obj = this.file.find(e => e.proveedor_id == detail.proveedor_id && e.order_id === detail.olab_id)
                    if(typeof obj != 'undefined'){
                        this.file[this.file.indexOf(obj)].file = data
                        this.file[this.file.indexOf(obj)].check = detail.check
                    }else{
                        this.file.push({
                            file: data,
                            proveedor_id: detail.proveedor_id,
                            order_id: detail.olab_id,
                            check : detail.check
                        })
                    }
                    let index = this.dataDetailOrder.details.indexOf(detail)
                    this.dataDetailOrder.details[index].path= res.data[0].file
                    this.dataDetailOrder.details[index].fileCharged=true
                    this.$emit('setOverlay',false)   
                
                }).then(()=>{
                    this.$emit('setOverlay',false)   
                })
                
            }
        },

        viewPdf(detail,binder){
            window.open(this.urlApi+'file.php?file='+binder+'/'+detail)
            this.setUrl('ordenes-laboratorio/1')
            this.requestApi({
                method: 'PUT',
                data:{
                    preview : 'irewniubn',
                    file :detail,
                    userLoginId : this.user.user_ligin_id,
                    system: 'laboratorio',
                    dataBase: 'obinnoclinica',
                    comment: this.user.user_ligin_id+' se ha descargado el archivo '+detail
                }
            }).then(res=>{
                
            })
        },

        setHeaderFeet(detail){
            let obj = this.file.find(e => e.proveedor_id == detail.proveedor_id && e.order_id === detail.olab_id)
            if(typeof obj != 'undefined')
                this.file[this.file.indexOf(obj)].check = detail.check
        },

        previewFile(archive,binder){
            window.open(this.urlApi+'file.php?file='+binder+'/'+archive)
        },

        deleteFile(detail){
            this.$emit('setOverlay',true)   
            this.setUrl('ordenes-laboratorio')
            this.requestApi({
                method: 'DELETE',
                data:{
                    archive: detail.archive.split("/")[detail.archive.split("/").length-1],
                    olab_id : detail.olab_id,
                    proveedor_id: detail.proveedor_id,
                    directory : this.directoryPDF,
                    userLoginId : this.user.user_ligin_id,
                    system: 'laboratorio',
                    dataBase: 'obinnoclinica'
                }
            }).then(res=>{
                this.$emit('setOverlay',false)   
                this.alertNotification({
                    param:{
                        html : res.detail
                    }
                })
                let obj =  this.dataDetailOrder.details.find(e=> e.proveedor_id == detail.proveedor_id && e.print )
                if(typeof obj != 'undefined')
                    obj.archive = this.pathFileOrder+'null.pdf'

                this.$emit('setState','Solicitado')
                this.$emit('setOverlay',false)   
                
            }).then(()=>{
                this.$emit('setOverlay',false)   
            }).catch(()=>{
                this.$emit('setOverlay',false)   
            })
        },

        storeFile(){
            this.setUrl('ordenes-laboratorio')
            this.$emit('setOverlay',true)   
            let formData = new FormData();
            let arr =[]
           
            this.file.map((data,x) => {
                formData.append('file_'+x,data.file)
                arr.push(data)
            })
            
            formData.append('data', JSON.stringify(arr))
            formData.append('directory', this.directoryPDF)
            formData.append('directoryTemp', this.directoryTemp)
            formData.append('preview',false)
            formData.append('pathCompleMent',this.directoryComplement)
            formData.append('log', JSON.stringify({
                userLoginId : this.user.user_ligin_id,
                system: 'laboratorio',
                dataBase: 'obinnoclinica'
            }))
            axios.post(
                this.url,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': 'Bearer '+ this.token
                    }
                }
            ).then(res=>{
                for(let i in res.data){
                    let obj =  this.dataDetailOrder.details.find(e=> e.proveedor_id == res.data[i].provider && e.print )
                    if(typeof obj != 'undefined')
                        obj.archive = this.pathFileOrder+res.data[i].file       
                }              
                this.file=[]
                this.$emit('storeFile',true)
                this.$emit('setOverlay',false)   
            }).then(()=>{
                this.$emit('setOverlay',false)
            })
        },

        closeDialogOrder(){
            this.$emit('closeDialog',false)
        },

        setFileC(detail){
            this.$emit('setFileCharge',detail)
        },

        sendAccess(){
            this.$emit('setOverlay',true)   
            this.setUrl('ordenes-laboratorio')
            this.setLoadingBtn()
          
            this.requestApi({
                method:'PATCH',
                data:{
                    data:{
                        identification: this.dataDetailOrder.identification,
                        email: this.dataDetailOrder.email,
                        olabId : this.dataDetailOrder.order
                    }
                }
            }).then(res=>{
                this.$emit('setOverlay',false)   
                if(res.data.status === 200){
                    this.alertNotification({
                        param:{
                            html : res.data.detail
                        }
                    })
                }
               console.log(res)
                
            })

        }
    }

}
</script>